"use client";

import { useEffect, useState, useRef } from "react";
import useApiQuery from "lib/api/useApiQuery";
import { BlockItem } from "./types";

export const useBlocks = () => {
  const { data: blocksData } = useApiQuery("homepage_blocks", {
    queryOptions: {
      refetchInterval: 3000,
    },
  });

  const blocks = (blocksData as BlockItem[])?.slice(0, 3) || [];
  const [newItemId, setNewItemId] = useState<number | null>(null);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const prevFirstIdRef = useRef<number | null>(null);

  useEffect(() => {
    if (blocks.length > 0) {
      const currentFirstId = blocks[0].height;
      if (
        prevFirstIdRef.current !== null &&
        prevFirstIdRef.current !== currentFirstId
      ) {
        setNewItemId(currentFirstId);
        setTimeout(() => setNewItemId(null), 500);
      }
      prevFirstIdRef.current = currentFirstId;
      if (isFirstLoad) setIsFirstLoad(false);
    }
  }, [blocks, isFirstLoad]);

  return { blocks, isFirstLoad, newItemId };
};
